import React from 'react'

import Translator from 'bazinga-translator'

import Btn from '../../../../Btn'
import withCondition from '../../../../withCondition'
import { getPlayForFunHref } from './utils'

interface Props {
  forFunPlayUrl: string
}

function PlayForFunButton({ forFunPlayUrl }: Props) {
  const href = getPlayForFunHref(forFunPlayUrl)

  return (
    <Btn
      link
      sm
      href={href}
    >
      {Translator.trans('play_for_fun', {}, 'games')}
    </Btn>
  )
}

export default withCondition(PlayForFunButton)
